const ARBITRUM_TESTNET_ADDRESSES: {[key: string]: `0x${string}`} = {
    'aggregatorV3': '0x62CAe0FA2da220f43a51F86Db2EDb36DcA9A5A08',
    'blockPotToken': '0xd457c7f74859FcB5bF1Cb078617999C906261a7c',
    'configManager': '0x97F244cD00793D56a2cD8c645AeFCD3d030Ce8aE',
    'contributorsRewardTracker': '0x10E79FC7DDe823Ee146B9f5914a0dDdA9f0414B5',
    'fundsManager': '0x76e161eA9377341Fb331947dDB0B10FE44635F83',
    'link': '0xd14838A68E8AFBAdE5efb411d5871ea0011AFd28',
    'linkEthFeed': '0x1AdDb2368414B3b4cF1BCe7A887d2De7Bfb6886f',
    'lottery': '0xcB6a94FA4A8FF21a909caD81D2FfF609279B5F0e',
    'lotteryRandomNumberProvider': '0x6AA43c2Bb116723896e2750D1f93d64E40EA16F7',
    'referralManager': '0x0d49D2A0145459A233d5dACC61E9e91a59EE7687',
    'rewardTracker': '0xa4e514b09bB8e95b0153261fBD6d63Aa28559158',
    'weth': '0xEe01c0CD76354C383B8c7B4e65EA88D00B06f36f',
    'wrapper': '0x674Cda1Fef7b3aA28c535693D658B42424bb7dBD'
}

export default ARBITRUM_TESTNET_ADDRESSES